export const orgCats = [
    { value: "NONPROFIT", display: "Non-Profit" },
    { value: "EDUCATION", display: "Education" },
    { value: "COMMERCIAL", display: "Commercial" },
    { value: "GOVERNMENT", display: "Government" },
    { value: "OTHER", display: "Other" },
];

export const errMsg =
    "It looks like you don't have a correct token or email. Please try logging in again.";
